'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');

var Top = require('./Top.jsx');
var Bottom = require('./Bottom.jsx');
var Middle = require('./Middle.jsx');
var Popup = require('./Popup.jsx');

var PopupHelper = require('./../../interactive/PopupHelper');
var interactiveManager = require('./../../interactive/InteractiveManager');

var appTypes = require('../../types/appTypes');
var InteractiveType = require('../../interactive/InteractiveTypes.js');
var helper = require('../../helper/componentHelper.js');
var pageHelper = require('./../../helper/pageHelper.js');
var linkHelper = require('../../helper/linkHelper');
var comHelper = require('../../helper/componentHelper.js');
var dataHelper = require('../../helper/dataHelper');

var timeLogHelper = require('../../helper/timeLogHelper');
var RunTimeOptions = require('../RuntimeOption');

var Page = React.createClass({
  propTypes: {
    page: React.PropTypes.object.isRequired,
    size: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number
    }).isRequired,
    domSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number
    }),
    canFix: React.PropTypes.bool.isRequired,
    appOrientation: React.PropTypes.string.isRequired,
    onLinkClick: React.PropTypes.func.isRequired,
    onShowRemark: React.PropTypes.func.isRequired
  },
  getInitialState: function () {
    return {
      page: JSON.parse(JSON.stringify(this.props.page))
    };
  },
  componentWillMount: function () {
    this.startMount = Date.now();
  },
  componentWillReceiveProps: function (nextProps) {
    this.setState({
      page: nextProps.page
    });
  },
  componentDidUpdate: function () {
    if (this.state.transitions) {
      this.state.transitions.forEach(function (transition) {
        $('#' + transition.id).css({
          left: 0,
          top: 100
        }).transition(transition.animation);
      });
    }
    this.startAllLoadInteractive(false);
  },
  componentDidMount: function () {
    PopupHelper.init();
    delete RunTimeOptions.eventTargetCom;
    this.startAllLoadInteractive(true);
    $(ReactDOM.findDOMNode(this)).bind('onScreenClick', this.onScreenClick);
    timeLogHelper.logPageRender(this.props.page.ID, this.props.page.title, Date.now() - this.startMount);
  },

  isLoaded: false,
  isLoadInteractiveStart: false,

  startAllLoadInteractive: function (isCreate) {
    this.isLoaded = this.props.isLoaded;
    if (this.isLoaded && !this.isLoadInteractiveStart) {
      this.isLoadInteractiveStart = true;
    } else {
      return;
    }
    if (!this.state.page.controls.control) {
      return;
    }
    var self = this;

    var fx = function (items) {
      var comp;
      var i;
      for (i = 0; i < items.length; i++) {
        comp = items[i];
        if (pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)) {
          comp.onOpened = self.doPopupOpened;
          continue;
        }
        self.doStartCompLoadInteractive(comp);
        if (comp.items) {
          fx(comp.items);
        }
      }
    };

    interactiveManager.reset();

    fx(this.state.page.controls.control);

  },

  doPopupOpened: function (comp) {
    this.doStartPopupChildCompLoadInteractive(comp);
  },

  doStartPopupChildCompLoadInteractive: function (comp) {
    var i;
    var c;
    if (comp.items && comp.items.length) {
      for (i = 0; i < comp.items.length; i++) {
        c = comp.items[i];
        this.doStartCompLoadInteractive(c);
        if (c.items && c.items.length) {
          this.doStartPopupChildCompLoadInteractive(c);
        }
      }
    }
  },


  doStartCompLoadInteractive: function (comp) {
    var index;
    var e;
    var entries;
    var hasLoadInteractive = false;
    if (comp.interactiveData) {
      entries = comp.interactiveData.entry;
      for (index = 0; index < entries.length; index++) {
        e = comHelper.findEventByType(comp, index, 'atLoad');
        if (e) {
          this.interceptSelfLoad(comp, appTypes.ActionResponseType.INTERACTIVE, index);
          hasLoadInteractive = true;
        }
      }
    }

    if (hasLoadInteractive) {
      this.startLoadInteractiveCount++;
    }

  },

  render: function () {
    var page = this.state.page;
    var sizeAndFix = this.computeSizeAndFix();
    var domSize = this.props.domSize;
    var normalComponents = _.filter(page.controls.control, function (comp) {
      return !comp.isCommentCom && !pageHelper.IsInvisualInteractiveCom(comp.controlTypeID);
    });
    var i;
    var comp;
    var popupComponents = [];
    if (page.controls.control) {
      for (i = 0; i < page.controls.control.length; i++) {
        comp = page.controls.control[i];
        if (pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)) {
          if (comp.popup) {
            popupComponents.push(comp)
          }
        }
      }
    }
    var events = {
      doSelfClick: this.interceptSelfClick,
      doSelfDbClick: this.interceptSelfDbClick,
      doSelfRightClick: this.interceptSelfRightClick,
      doSelfLoad: this.interceptSelfLoad,
      doSelfChecked: this.interceptSelfChecked,
      doSelfLongPress: this.interceptSelfLongPress,
      onTransit: this.onTransit,
      onShowRemark: this.props.onShowRemark
    };
    var screenSize;
    var screenOrientation = this.props.page.screenOrientation;
    var appOrientation = this.props.appOrientation;
    if (screenOrientation && appOrientation && (screenOrientation !== appOrientation)) {
      screenSize = {
        width: page.defaultH,
        height: page.defaultW
      };
    } else {
      screenSize = {
        width: page.defaultW,
        height: page.defaultH
      };
    }
    return (
      <div className='page' id={this.props.page.ID}
           style={{
             backgroundColor: this.props.page.param ? this.props.page.param[0].backgroundColor : '#fff'
           }}
           onClick={this.onPageClick}>
        {sizeAndFix.top > 0 &&
        <Top
          components={normalComponents}
          top={sizeAndFix.top}
          events={events}
          onLinkClick={this.props.onLinkClick}
        />
        }
        <Middle
          components={normalComponents}
          screenSize={screenSize}
          pageSize={{
            width: sizeAndFix.width,
            height: sizeAndFix.height
          }}
          canFix={this.props.canFix}
          domSize={domSize}
          top={sizeAndFix.top}
          bottom={sizeAndFix.bottom}
          events={events}
          onLinkClick={this.props.onLinkClick}
        />
        {
          sizeAndFix.bottom > 0 &&
          <Bottom
            components={normalComponents}
            pageSize={{
              width: sizeAndFix.width,
              height: sizeAndFix.height
            }}
            bottom={sizeAndFix.bottom}
            events={events}
            onLinkClick={this.props.onLinkClick}
          />
        }
        {
          popupComponents.length > 0 && <Popup
            components={popupComponents}
            pageSize={{
              width: page.defaultW,
              height: page.defaultH
            }}
            height={page.defaultH}
            events={events}
            onLinkClick={this.props.onLinkClick}
          />
        }
      </div>
    );
  },

  onPageClick: function (e) {
    PopupHelper.mousePoint = {
      x: e.pageX,
      y: e.pageY
    };
    e.stopPropagation();
    e.nativeEvent.stopPropagation();
    this.doTriggerClosePopup(e);
  },

  onScreenClick: function (e, me) {
    this.doTriggerClosePopup(e);
    //$('.popup-control').trigger(PopupHelper.CLOSE_POPUP_EVENT, {
    //  callback: this.doClosePopup
    //});
  },

  doTriggerClosePopup: function (e, call, noClosePopups) {
    var i;
    var c;
    var comp;
    var controls;
    var self = this;
    var finishCount = 0;
    var popupCount;
    var func = function () {
      finishCount++;
      if (finishCount !== popupCount) {
        return;
      }
      if (call) {
        call();
      }
    };
    var noClosePopupID;
    var idStr = '';
    if (noClosePopups && noClosePopups.length) {
      noClosePopupID = [];
      for (i = 0; i < noClosePopups.length; i++) {
        noClosePopupID.push(noClosePopups[i].controlID);
      }
      idStr = noClosePopupID.join(',');
    }
    if (this.state.page.controls) {
      controls = this.state.page.controls.control;
      if (controls && controls.length) {

        //c = $('.popup-control');
        //popupCount = c.length;
        //if (c.length) {
        //  for (i = 0; i < c.length; i++) {
        //    $(c[i]).trigger(PopupHelper.CLOSE_POPUP_EVENT, {
        //      callback: function (popupID) {
        //        self.doClosePopup(popupID, func)
        //      },
        //      mousePoint: {
        //        x: e.pageX,
        //        y: e.pageY
        //      }
        //    });
        //  }
        //} else {
        //  if (call) {
        //    call();
        //  }
        //}

        //popupCount = 0;
        //for(i = 0;i<controls.length;i++){
        //  comp = controls[i];
        //  if(pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)){
        //    if(comp.closeWithTrigger){
        //      continue;
        //    }
        //    if(comp.popup)
        //      popupCount ++;
        //  }
        //}

        popupCount = $('.popup-control').length;
        if (noClosePopupID) {
          popupCount -= noClosePopupID.length;
        }
        if (popupCount > 0) {
          for (i = 0; i < controls.length; i++) {
            comp = controls[i];
            if (pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)) {
              if (idStr.indexOf(comp.controlID) !== -1) {
                continue;
              }
              c = $('#' + comp.controlID);
              if (c.length) {
                c.trigger(PopupHelper.CLOSE_POPUP_EVENT, {
                  callback: function (popupID) {
                    self.doClosePopup(popupID, func);
                  },
                  mousePoint: {
                    x: e.pageX,
                    y: e.pageY
                  },
                  controlID: comp.controlID
                });
              }
            }
          }
        } else {
          if (call) {
            call();
          }
        }
      }
    }
    /*
     todo mxj 下一步考虑弹出组件关闭的策略为，任何时候的点击事件，先主动冒泡到Page或者Screen中的某个事件，然后触发弹出组件的全局点击事件来关闭，而交互组件的点击需要在这个动作之后，减小回调的可能
     弹出组件中，该事件还未处理
     */
    //$('.popup-control').trigger('onScreenClick',{event:e,callback:this.doClosePopup});
  },

  doClosePopup: function (popupID, call) {
    var data = this.state.page;
    var comp;
    if (popupID) {
      comp = this.findComByID(popupID);
      if (comp) {
        comp.popup = false;
        delete comp.closeWithTrigger;
        pageHelper.updatePageComData(data, comp);
        this.refresh(data);
      }
    }
    if (call) {
      call();
    }
  },

  computeSizeAndFix: function () {
    var page = this.state.page;
    var clipArea = page.clipArea;
    var size = this.props.size;
    var width = parseInt(page.measureW, 10);
    var height = parseInt(page.measureH, 10);
    var arr;
    if (!this.props.canFix) {
      return {
        top: 0,
        bottom: 0,
        width: width,
        height: height
      };
    }
    if (!clipArea || clipArea === '(0,0,0,0)') {
      return {
        width: width,
        height: height,
        top: 0,
        bottom: 0
      };
    }
    arr = clipArea.split(',');
    return {
      width: width,
      height: height,
      top: parseInt(arr[1], 10),
      bottom: height - parseInt(arr[3], 10)
    }
  },


  getPopupTargetsBy: function (comp, index, eventType, linkKey) {
    var interactiveData = comp.interactiveData;
    var entries;
    var entry;
    var events;
    var event;
    var behaviour;
    var target;
    var i;
    var targets = [];
    if (linkKey === appTypes.ActionResponseType.INTERACTIVE) {
      if (interactiveData) {
        entries = interactiveData.entry;
        entry = entries[index];
        events = entry.events;
        if (events.event) {
          for (i = 0; i < events.event.length; i++) {
            event = events.event[i];
            if (event.eventType === eventType) {
              behaviour = event.behaviour[0];
            }
          }
        }
        if (behaviour) {
          if (behaviour.target) {
            for (i = 0; i < behaviour.target.length; i++) {
              target = behaviour.target[i];
              target = this.findComByID(target.targetID);
              if (pageHelper.IsInvisualInteractiveCom(target.controlTypeID)) {
                if (target.popup) {
                  targets.push(target);
                }
              }
            }
          }
        }
      }
    }
    return targets;
  },

  interceptSelfClick: function (evt, componentData, linkKey, index) {
    var self = this;
    this.doTriggerClosePopup(evt, function () {
      self.doStartInteractiveOrSkipPage(componentData, linkKey, index);
    }, this.getPopupTargetsBy(componentData, index, InteractiveType.InteractiveTypes.EventType.CLICK, linkKey));
  },

  doStartInteractiveOrSkipPage: function (componentData, linkKey, index) {
    if (linkKey === appTypes.ActionResponseType.LINK) {
      this.interceptLinkClick(componentData.links, index);
    } else if (linkKey === appTypes.ActionResponseType.INTERACTIVE) {
      this.interceptInteractiveEvent(componentData, InteractiveType.InteractiveTypes.EventType.CLICK, index);
    } else if (linkKey === appTypes.ActionResponseType.OUTER) {
      this.interceptExternalLinkEvent(componentData);
    }
  },

  interceptSelfLongPress: function (evt, comData, index) {
    var self = this;
    this.doTriggerClosePopup(evt, function () {
      self.interceptInteractiveEvent(comData, InteractiveType.InteractiveTypes.EventType.LONG_PRESS, index);
    });
  },

  interceptSelfChecked: function (evt, componentData, isChecked, linkKey, index) {
    var eventType;
    if (_.isUndefined(index)) {
      index = 0;
    }
    var self = this;
    this.doTriggerClosePopup(evt, function () {
      if (linkKey !== appTypes.ActionResponseType.INTERACTIVE) {
        self.interceptSelfClick(evt, componentData, linkKey, index)
      } else {
        eventType = isChecked ? InteractiveType.InteractiveTypes.EventType.CHECK_TRUE : InteractiveType.InteractiveTypes.EventType.CHECK_FALSE;
        self.interceptInteractiveEvent(componentData, eventType, index);
      }
    });
  },

  interceptSelfDbClick: function (evt, comDatas, index) {
    this.interceptInteractiveEvent(comDatas, InteractiveType.InteractiveTypes.EventType.DOUBLE_CLICK, index);
  },

  interceptSelfRightClick: function (evt, comDatas, index) {
    this.interceptInteractiveEvent(comDatas, InteractiveType.InteractiveTypes.EventType.RIGHT_CLICK, index);
  },

  interceptSelfLoad: function (comDatas) {
    this.interceptInteractiveEvent(comDatas, InteractiveType.InteractiveTypes.EventType.LOAD);
  },

  interceptExternalLinkEvent: function (componentData) {
    if (componentData.externalURL) {
      var externalURL = componentData.externalURL;
      externalURL = dataHelper.decodeURIComponent(externalURL);
      if (externalURL.indexOf('http://') === -1) {
        externalURL = 'http://' + externalURL;
      }
      window.open(externalURL);
    }
  },


  /**
   * 拦截组件链接点击事件
   * @param links: 链接对象
   * @param index： 当前点击的链接索引序号
   */
  interceptLinkClick: function (links, index) {
    var link;
    var targetPageID;
    var animateType;
    var animateDuration;

    if (links && (index !== undefined)) {
      link = links.link[index];

      if (link && link.targetPageID && (link.linkType === appTypes.PageLinkType.PAGE_LINK)) {

        targetPageID = link.targetPageID;
        animateType = linkHelper.getLinkAnimateBySaveLinkAnimate(links.animate);
        animateDuration = parseInt(links.animateDuration, 10);
        this.setState({page: this.props.page});

        this.props.onLinkClick(targetPageID, {
          name: animateType,
          duration: animateDuration,
          timing: 'linear'
        });
      }
    }
  },


  /**
   * 拦截交互事件，同时派发组件交互事件
   * @param comDatas 组件数据
   * @param eventType 事件类型
   * @param entryIndex 响应用户事件的入口索引
   */
  interceptInteractiveEvent: function (comDatas, eventType, entryIndex) {
    this.dispatchInteractive(comDatas, eventType, entryIndex);
  },


  /***
   * 派发一个交互事件，并执行
   * @param sourceNode
   * @param eventType
   * @param entryIndex
   */
  dispatchInteractive: function (sourceNode, eventType, entryIndex) {
    interactiveManager.start(this, sourceNode, eventType, entryIndex);
  },

  refresh: function (newPage) {
    this.setState({page: newPage});
  },


  /**
   * 根据组件ID查找组件数据，该数据是从当前页面的状态数据中查找，而不是原始数据
   * @param comID 组件ID
   */
  findComByID: function (comID) {
    return pageHelper.getControlDataByComID(this.state.page, comID);
  },

  /***
   * 获取事件源组件相对于页面的绝对区域
   * @param targetDom
   * @returns {{left: number, top: number, right: number, bottom: number}}
   */
  getTargetEventComAbsoluteRect: function (targetDom) {
    var rect = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    if (!targetDom) {
      return rect;
    }

    var pageDom = ReactDOM.findDOMNode(this);//$('#' + this.props.page.ID)[0];


    var parentDom = targetDom.parentElement;

    rect.top = targetDom.offsetTop;
    rect.left = targetDom.offsetLeft;

    //根据Dom来获取相对于page的绝对坐标
    while (parentDom !== pageDom) {
      parentDom = parentDom.parentElement;
      if (parentDom) {
        rect.top += (parentDom.offsetTop - parentDom.scrollTop);
        rect.left += (parentDom.offsetLeft - parentDom.scrollLeft);
      } else {
        break;
      }
    }
    rect.right = rect.left + targetDom.clientWidth;
    rect.bottom = rect.top + targetDom.clientHeight;
    return rect;
  },

  onTransit: function (transitions) {
    if (!_.isArray(transitions)) {
      transitions = [transitions];
    }
    this.setState({
      transitions: transitions
    });
  },

  getClipAreaScrollView: function () {
    var controls = this.state.page.controls;
    var c;
    var i;
    if (controls) {
      if (controls.control) {
        for (i = 0; i < controls.control.length; i++) {
          c = controls.control[i];
          if (c.alias === '__________________________ClidArea_______________________0000000000000000000000') {
            return c;
          }
        }
      }
    }
    return null;
  }
});

module.exports = Page;


/** WEBPACK FOOTER **
 ** ./src/views/Page/Page.jsx
 **/